<template>
<div>
    <div class="object-right-bottom right-0 mr-5 mb-5 bottom-0 absolute z-50">
      
        <!--completado con texto-->
        <div v-if="completed" class="shadow-xl flex-row mb-1 rounded bg-gradient-to-r from-green-300 via-green-400 to-green-500 border-green-900">
        
            <div class="p-1 flex items-center">
            
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>

                <h3 class="p-1 text-sm font-medium text-gray-700">
                  {{titulo}}
                </h3>

            </div>

            <div v-if="contenido.length >= 1" class="truncate p-1 text-sm text-gray-700">
                <div class="flex items-center space-y-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span class="truncate">{{contenido}}</span>
                </div>
            </div>

            <div v-if="cerrar" class="mt-2 border border-b-0 border-l-0 border-r-0 border-t border-white flex items-center">

                <div class="pointer px-2 py-1.5 rounded text-sm font-medium text-gray-700 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  <!--Opcional-->
                </div>

                <div @click="()=>{this.completed = false}" class="pointer px-2 py-1.5 rounded text-sm font-medium text-gray-700 hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  Cerrar
                </div>

            </div>

        </div>
        <!--completado con texto-->

        <!--advertencia-->
        <div v-if="warning" class="shadow-xl flex-row mb-1 rounded bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-500 border-yellow-900">
        
            <div class="p-1 flex items-center">
            
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01" />
                </svg>

                <h3 class="p-1 text-sm font-medium text-gray-700">
                  {{titulo}}
                </h3>

            </div>


            <div v-if="contenido.length >= 1" class="truncate p-1 text-sm text-gray-700">
            
                <div class="flex items-center space-y-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span class="truncate">{{contenido}}</span>
                </div>
            </div>

            <div v-if="cerrar" class="mt-2 border border-b-0 border-l-0 border-r-0 border-t border-white flex items-center">

                <div class="pointer px-2 py-1.5 rounded text-sm font-medium text-gray-700 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  <!--Opcional-->
                </div>

                <div @click="()=>{this.warning = false}" class="pointer px-2 py-1.5 rounded text-sm font-medium text-gray-700 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  Cerrar
                </div>

            </div>

        </div>
        <!--advertencia-->

        <!--alerta-->
        <div v-if="alert" class="shadow-xl flex-row mb-1 rounded bg-gradient-to-r from-red-300 via-red-400 to-red-500 border-red-900">
        
            <div class="p-1 flex items-center">
          
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-1 h-5 w-5 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>

                <h3 class="text-sm font-medium text-gray-800">
                  {{titulo}}
                </h3>

            </div>

            <div v-if="contenido.length >= 1" class="p-1 truncate text-sm text-gray-800">   
                <div class="flex items-center space-y-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-1 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span class="truncate">{{contenido}}</span>
                </div>
            </div>

            <div v-if="cerrar" class="mt-2 border border-b-0 border-l-0 border-r-0 border-t border-white flex items-center">
              
            <div class="pointer px-2 py-1.5 rounded text-sm font-medium text-gray-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
              <!--Opcional-->
            </div>

            <div @click="()=>{this.alert = false}" class="pointer px-2 py-1.5 rounded text-sm font-medium text-gray-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
              Cerrar
            </div>

            </div>

        </div>
        <!--alerta-->

        <!--alertas lista-->
        <div v-if="listalert" class="shadow-xl flex-row mb-1 rounded bg-gradient-to-r from-red-300 via-red-400 to-red-500 border-red-900">
        
            <div class="p-1 flex items-center">
          
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-1 h-5 w-5 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>

                <h3 class="text-sm font-medium text-gray-800">
                  {{titulo}}
                </h3>

            </div>

            <div v-if="contenido.length >= 1" class="p-1 truncate text-sm text-gray-800">
                <div class="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-1 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span class="p-1 truncate">{{contenido}}</span>
                </div>
            </div>

            <div class="mt-1 text-sm">
                <div class="list-disc pl-5 space-y-1">
                    <p :key="error.index" class="text-gray-800" v-for="(error,key,index) in errores">
                        • {{error}}
                    </p>
                </div>
            </div>

            <div v-if="cerrar" class="mt-2 border border-b-0 border-l-0 border-r-0 border-t border-white flex items-center">
              
                <div class="pointer px-2 py-1.5 rounded text-sm font-medium text-gray-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  <!--Opcional-->
                </div>

                <div @click="()=>{this.listalert = false}" class="pointer px-2 py-1.5 rounded text-sm font-medium text-gray-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  Cerrar
                </div>

            </div>

        </div>
        <!--alertas lista-->

        <!--informativo-->
        <div v-if="info" class="shadow-xl flex-row mb-1 rounded bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 border-blue-900">
        
            <div class="p-1 flex items-center">
            
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>

                <h3 class="p-1 text-sm font-medium text-white">
                  {{titulo}}
                </h3>

            </div>

            <div v-if="contenido.length >= 1" class="truncate p-1 text-sm text-white">
                <div class="flex items-center space-y-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span class="truncate">{{contenido}}</span>
                </div>
            </div>

            <div v-if="cerrar" class="mt-2 border border-b-0 border-l-0 border-r-0 border-t border-white flex items-center">

                <div class="pointer px-2 py-1.5 rounded text-sm font-medium text-white hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  <!--Opcional-->
                </div>

                <div @click="()=>{this.info = false}" class="pointer px-2 py-1.5 rounded text-sm font-medium text-white hover:text-blue-500 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  Cerrar
                </div>

            </div>

        </div>
        <!--informativo-->

        <!--realizado-->
        <div v-if="success" class="mb-2 rounded bg-gradient-to-r from-green-300 via-green-400 to-green-500 border-green-900 p-4">
          <div class="flex">

            <div class="">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
            </div>

            <div class="ml-3">
              <p class="text-sm font-medium text-gray-600">
                {{titulo}}
              </p>
            </div>

            <div v-if="cerrar" class="ml-auto pl-3">
                <div @click="()=>{this.success = false}" class="inline-flex border border-green-100 rounded text-green-100 hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600">
                  <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </div>
            </div>
          </div>
        </div>
        <!--realizado-->

    </div>
  
    <!--chat de ayuda-->
    <div v-if="user.id==0" @mouseleave="icons = false" class="object-right-bottom right-0 bottom-0 z-50 fixed">
      <div v-if="icons" class="pointer">
          <a target='_blank' href="https://t.me/Rockhount793" >
            <img class="h-14 w-14" :src="urlsf + 'images/telegram-l.svg'" alt="telegram" />
          </a>
      </div>
      <div v-if="icons" class="pointer">
          <a target='_blank' href="https://api.whatsapp.com/send?phone=573126665895&text=Hola!%20Quiero%20mas%20informacion!" >
            <img class="h-14 w-14" :src="urlsf + 'images/whatsapp-l.svg'" alt="whatsapp" />
          </a>
      </div>
      <div class="mb-1 mr-1">
          <div @mouseover="icons = true">
            <img class="h-14 w-14" :src="urlsf + 'images/burbuja-chat.svg'" alt="burbuja-chat" />
          </div>
      </div>
    </div>
    <!--chat de ayuda-->
</div>
</template>
<!-- tipos de notificaión //advertencia, completado, realizado, alerta, alertas, informativo // -->
<script>
    
    import Store from '@/store/index'
  
    export default {

        name: 'notificacionlocal',
  
        data(){
            return{
              titulo:'',
              contenido:'',
              errores:[],
              alert:false,
              warning:false,
              info:false,
              success:false,
              completed:false,
              cerrar:false,
              listalert:false,
              icons:false,
            }
        },

        methods:{

            run_notify(i){

                this.titulo = i.titulo
                this.contenido = i.contenido 
                this.cerrar = i.cerrar
                this.errores = i.errores
                var x = i.tipo

                switch(x){

                  case 'completado':this.completed=true; break;
                  case 'alerta':this.alert=true; break;
                  case 'advertencia':this.warning=true; break;
                  case 'realizado':this.success=true; break;
                  case 'informativo':this.info=true; break;
                  case 'alertas':this.listalert=true; break;
                }

                setTimeout(()=>{this.restablecer()},i.tiempo);
                setTimeout(()=>{this.destruir()},i.tiempo);

            },

            destruir(){
                Store.commit('set_notificacion_local',{'run':false,'tipo':'','titulo':'','contenido':'','errores':[],'tiempo':0,'cerrar':false})
            },

            restablecer(){
                this.titulo= '';
                this.contenido='';
                this.errores=[];
                this.alert = false;
                this.completed = false;
                this.warning = false;
                this.info = false;
                this.success = false;
                this.cerrar = false;
                this.listalert= false
            },

            call_notifi(){
                //tipos de notificación advertencia, completado, realizado, alerta, alertas, informativo
                var i = Store.state.notificacion_local
                //var i = {'run':true,'tipo':'informativo','titulo':this.user.email,'contenido':'El objetivo se llevo a cabo satisfactoriamente!','errores':['un error','otro error'],'tiempo':10000,'cerrar':true} 
                if(i.run){ this.run_notify(i) }
                return i.run
            }

        },
    
        computed:{

            urlsf(){ return Store.state.urlsf },
            user(){ return Store.state.user },
            notificacion(){ return Store.state.notificacion_local },

        },

        filters:{

        },

        mounted(){
        
        },

        watch:{
            notificacion(){
                this.call_notifi()
            }
        }
    }


</script>

<style scoped>

</style>